export * from "@/ui/components/data-display/Table/Table";
export * from "@/ui/components/data-display/Table/Table.config";
export * from "@/ui/components/data-display/Table/TBody";
export * from "@/ui/components/data-display/Table/TD";
export * from "@/ui/components/data-display/Table/TH";
export * from "@/ui/components/data-display/Table/THead";
export * from "@/ui/components/data-display/Table/TR";
